// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9988) return "static/chunks/9988-aa30b042b445ae92.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1331":"69e7151096188000","2848":"461aff1818909490","4907":"cc79f98a79135297","5492":"39b5b93b0b9aebfb","5497":"e0a7bf44b2f1392c","6234":"bc46996f9957fc19"}[chunkId] + ".js";
};